// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"443":"about","809":"transfer"}[chunkId] + "." + {"443":"938af0e0","809":"87f6985e"}[chunkId] + ".css";
};